<template>
  <NsProductDetailBase
    :adr-price="adrPrice"
    :adr-price-type="adrPriceType"
    :checked-qualifications="checkedQualifications"
    :description="description"
    :disable-add-to-adr="disableAddToAdr"
    :disable-add-to-cart="disableAddToCart"
    :disable-quantity-selector="disableQuantitySelector"
    :enable-pay-pal-text="!!marketConfig.enablePayPalText"
    :exclusive-offer-message="exclusiveOfferMessage"
    :feature-flags="featureFlags"
    :forcesv="forcesv"
    :hide-adr="hideAdr"
    :hide-exclusive-icon="hideExclusiveIcon"
    :hide-exclusive-text-on-mobile="hideExclusiveTextOnMobile"
    :hide-favorites="hideFavorites"
    :hide-info="hideInfo"
    :hide-sku="hideSku"
    :image-fallback-src="imageFallbackSrc"
    :image="image"
    :image-set="imageSet"
    :is-base-sku="isBaseSku"
    :is-distributor="isDistributor"
    :is-exclusive="isExclusive"
    :is-favorite="isFavorite"
    :is-logged-in="isLoggedIn"
    :is-loyalty-enabled="isLoyaltyEnabled"
    :is-sale="isSale"
    :loyalty-status-and-links="loyaltyStatusAndLinks"
    :market-attributes="marketAttributes"
    :max-quantity="maxQuantity"
    :min-price="minPrice"
    :max-price="maxPrice"
    :netto-weight="nettoWeight"
    :original-price="originalPrice"
    :original-price-label="originalPriceLabel"
    :original-price-type="originalPriceType"
    :points="points"
    :price="price"
    :price-label="priceLabel"
    :price-type="priceType"
    :product="product"
    :quantity="quantity"
    :sales-event-text="salesEventText"
    :sales-label="salesLabel"
    :show-adr-only="showAdrOnly"
    :show-adr-price="showadrprice"
    :show-exclusive-offer-message="showExclusiveOfferMessage"
    :show-original-crossed-out="showOriginalCrossedOut"
    :show-price-labels="showPriceLabels"
    :show-variant-selector="showVariantSelector"
    :size-weight="sizeWeight"
    :sku="activeSku"
    :status-message="statusMessage"
    :status-message-key="statusMessageKey"
    :title="title"
    :translations="localTranslations"
    :user-is-qualified="userIsQualified"
    :user-loyalty="userLoyalty"
    :variants="variants"
    :variant-skus="variantSkus"
    @variant-select="handleVariantSelect"
    @quantity-select="handleQuantitySelect"
    @add-to-cart="handleAddToCart"
    @add-to-adr="handleAddToAdr"
    @favorite-click="handleFavoriteClick"
    @image-select="handleImageSelect"
  >
    <template #shipping>
      <slot name="shipping" />
    </template>
    <template #refunds>
      <slot name="refunds" />
    </template>
  </NsProductDetailBase>
</template>

<script>
import NsProductDetailBase from "./NsProductDetailBase.vue";
import NsProductMixin from "../mixins/NsProductMixin.js";
import { events } from "@nuskin/ns-util";

/**
 * NsProductDetail
 *
 * How to use: Any variables used in the template that are not props in this
 * component come from the mixin.
 *
 * @event product-update  When a product is updated this event emits a function
 * with params: (product)
 */

export default {
  name: "NsProductDetail",
  components: {
    NsProductDetailBase
  },
  mixins: [NsProductMixin],
  props: {
    /**
     * Always show the sv value
     */
    forcesv: Boolean,
    /**
     * Hides the Exclusive Icon
     */
    hideExclusiveIcon: Boolean,
    /**
     * Hides Exclusive Text only on mobile
     */
    hideExclusiveTextOnMobile: Boolean,
    /**
     * Hides the Favorites Icon
     */
    hideFavorites: Boolean,
    /**
     * Hides the Info Section at the bottom
     */
    hideInfo: Boolean,
    /**
     * Hides the Sku number
     */
    hideSku: Boolean,
    /**
     * Force showing the ADR price
     * Warning: Don't change casing, named "showadrprice" in hello-ui
     */
    showadrprice: Boolean
  },
  data() {
    return {
      loadFirstVariant: true,
      referrer: "productPage"
    };
  },
  watch: {
    title() {
      this.sendAnalytics();
    }
  },
  methods: {
    sendAnalytics() {
      let tries = 0;
      this.analyticsInterval = setInterval(() => {
        if (window.dataLayer && window.ga && window.ga.loaded) {
          const impression = {
            event: events.shop.PRODUCT_IMPRESSION_DETAIL,
            ecommerce: {
              detail: {
                products: [
                  {
                    id: this.activeSku,
                    name: this.title
                    // TODO: uncomment below when these fields are available (contentstack is up)
                    // category: this.category,
                    // brand: this.brand,
                    // variant: this.variant
                  }
                ]
              }
            }
          };
          window.dataLayer.push(impression);
          clearInterval(this.analyticsInterval);
          this.analyticsInterval = null;
          return;
        }

        tries += 1;

        if (tries > 50) {
          clearInterval(this.analyticsInterval);
          this.analyticsInterval = null;
        }
      }, 200);
    }
  }
};
</script>
